import React, { useContext, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { Field, Formik, Form } from 'formik';
import * as Yup from 'yup';

import QuoterContext from '../../context/QuoterContext';

import PDFModal from '../modals/PDFModal';
import Button from '../commons/Button';

import axiosInstanceWee from '../../core/api-config';

import {
  maskDateInput,
  registerProgressInBackend,
  logProgressInVincoBack,
} from '../../core/helper-functions';

import { FORM1_SCHEMA } from '../../constants/validation-schemas';
import {
  FORM1_SUBMIT_URL,
  GET_TERMS_DOCUMENTS_URL,
} from '../../constants/constants';

const Form1 = () => {
  const { quoterContextValues, setQuoterContextValues } = useContext(QuoterContext);
  const formInitialValues = { ...quoterContextValues.form1 };
  const pdfDocuments = [...quoterContextValues.docs];
  const quoterIds = { ...quoterContextValues.ids };
  const [pdfModalSrc, setPdfModalSrc] = useState('');
  const [isDocsModalLoading, setIsDocsModalLoading] = useState(false);
  const [showDocsModal, setShowDocsModal] = useState(false);
  const formValidationSchema = Yup.object().shape(FORM1_SCHEMA);
  const browserHistory = useHistory();

  const formSubmitHandler = async (values, { setFieldError }) => {
    setQuoterContextValues({
      ...quoterContextValues,
      isAppLoading: true,
    });
    const submitValues = { ...values };
    submitValues.isAceptTCGD = submitValues.isAceptTCGD ? 1 : 0;
    submitValues.AvisoPrivacidad = submitValues.AvisoPrivacidad ? 1 : 0;
    submitValues.idTramite = quoterIds.idTramite;

    const formData = new URLSearchParams(submitValues);

    const submitFormPromise = await axiosInstanceWee.post(FORM1_SUBMIT_URL, formData);
    let isFormValid = false;
    let newQuoterValues = { ...quoterContextValues };
    const { Datos, Validacion } = submitFormPromise.data.dsRespuesta;

    if (Validacion) {
      const fieldKeys = Object.keys(submitValues);
      Validacion.forEach((val) => {
        fieldKeys.forEach((field) => {
          if (val.Detail.indexOf(field) !== -1) {
            setFieldError(field, 'Revisa que este campo sea correcto.');
          }
        });
      });
    } else if (Datos[0].isEdadValidate === 0) {
      setFieldError('FechaNacimiento', Datos[0].Mensaje);
    } else {
      isFormValid = true;
    }

    const idTramite = Datos[0] && Datos[0].idTramite
      ? Datos[0].idTramite
      : quoterContextValues.ids.idTramite;

    newQuoterValues = {
      ...newQuoterValues,
      form1: values,
      ids: {
        ...newQuoterValues.ids,
        idTramite,
      },
      isAppLoading: false,
    };

    if (isFormValid) {
      await registerProgressInBackend(
        submitFormPromise.data.dsRespuesta.Datos[0].idTramite,
        100,
      );
      newQuoterValues = {
        ...newQuoterValues,
        ids: {
          ...newQuoterValues.ids,
          idPaso: 2,
        },
      };
      logProgressInVincoBack(
        newQuoterValues.ids.idTramite,
        new Date(),
        1,
        100,
        '002',
        submitFormPromise.status,
        submitFormPromise.status,
        null,
        submitFormPromise.data.Mensaje,
      );
      browserHistory.push('cotizador-2');
    }

    setQuoterContextValues(newQuoterValues);
  };

  const getDocSourceFromArray = (docs, docID) => {
    // This is weird, as the original code doesnt check for duplicates.
    // If you look at the server's response you'll find two items that pass this validation.
    // The original code triggers the modal launch for both and thus, only the second
    // source is shown because the code itself overwirtes the first element's source
    // So we will do the same, more efficiently, looking for the last instance for
    // the document labeled 'Aviso De Privacidad - this is the only one duplicated.
    const selectedDoc = docID.isTerminos === 'Aviso De Privacidad'
      ? docs.findLast((d) => d.isTerminos === 'Aviso De Privacidad')
      : docs.find((d) => d.isTerminos === docID);
    return selectedDoc.URLAzureBlob;
  };

  const handleDocumentsLinkClick = (event, docID) => {
    event.preventDefault();
    if (!pdfDocuments.length) {
      setIsDocsModalLoading(true);
      setShowDocsModal(true);
      const formData = new URLSearchParams({ idTramite: '' });
      axiosInstanceWee
        .post(GET_TERMS_DOCUMENTS_URL, formData)
        .then((res) => {
          const { Datos } = res.data.dsRespuesta;
          setPdfModalSrc(getDocSourceFromArray(Datos, docID));
          setQuoterContextValues({
            ...quoterContextValues,
            docs: Datos,
          });
        })
        .finally(() => setIsDocsModalLoading(false));
    } else {
      setShowDocsModal(true);
      setPdfModalSrc(getDocSourceFromArray(quoterContextValues.docs, docID));
    }
  };

  /**
   * Render Method
   */
  return (
    <Formik
      initialValues={formInitialValues}
      validationSchema={formValidationSchema}
      onSubmit={formSubmitHandler}>
      {({ errors, touched, isSubmitting, isValid, isValidating, setFieldValue }) => {
        return (
          <Form className="quoter-form">
            {
              showDocsModal
                ? (
                  <PDFModal
                    pdfSrc={pdfModalSrc}
                    isLoading={isDocsModalLoading}
                    onClose={() => setShowDocsModal(false)} />
                )
                : null
            }
            <h2>Registra tus datos</h2>
            <div className="form-fields">
              {/* NOMBRE && PATERNO */}
              <div className="field-row">
                <div className="field -input">
                  <label htmlFor="Nombre">Nombre (s) del asegurado:*</label>
                  {errors.Nombre && touched.Nombre && <div className="field-invalid">{errors.Nombre}</div>}
                  {!errors.Nombre && touched.Nombre && <div className="field-valid">ok</div>}
                  <Field name="Nombre" type="text" />
                </div>
                <div className="field -input">
                  <label htmlFor="Paterno">Apellido Paterno:*</label>
                  {errors.Paterno && touched.Paterno && <div className="field-invalid">{errors.Paterno}</div>}
                  {!errors.Paterno && touched.Paterno && <div className="field-valid">ok</div>}
                  <Field name="Paterno" type="text" />
                </div>
              </div>

              {/* MATERNO && TELEFONO */}
              <div className="field-row">
                <div className="field -input">
                  <label htmlFor="Materno">Apellido Materno*</label>
                  {errors.Materno && touched.Materno && <div className="field-invalid">{errors.Materno}</div>}
                  {!errors.Materno && touched.Materno && <div className="field-valid">ok</div>}
                  <Field name="Materno" type="text" />
                </div>
                <div className="field -input">
                  <label htmlFor="Telefono">Teléfono*</label>
                  {errors.Telefono && touched.Telefono && <div className="field-invalid">{errors.Telefono}</div>}
                  {!errors.Telefono && touched.Telefono && <div className="field-valid">ok</div>}
                  <Field
                    name="Telefono"
                    type="text"
                    maxLength="10" />
                </div>
              </div>

              {/* CORREO && NACIMIENTO */}
              <div className="field-row">
                <div className="field -input">
                  <label htmlFor="Email">Correo electrónico:*</label>
                  {errors.Email && touched.Email && <div className="field-invalid">{errors.Email}</div>}
                  {!errors.Email && touched.Email && <div className="field-valid">ok</div>}
                  <Field name="Email" type="text" placeholder="correo@correo.com" />
                </div>
                <div className="field -input">
                  <label htmlFor="FechaNacimiento">Fecha de nacimiento:*</label>
                  {errors.FechaNacimiento && touched.FechaNacimiento && <div className="field-invalid">{errors.FechaNacimiento}</div>}
                  {!errors.FechaNacimiento && touched.FechaNacimiento && <div className="field-valid">ok</div>}
                  <Field
                    name="FechaNacimiento"
                    type="text"
                    placeholder="DD/MM/AAAA"
                    maxLength="10"
                    onChange={(event) => maskDateInput(event, setFieldValue, 'FechaNacimiento')} />
                </div>
              </div>
              <div className="field-row">
                <div className="field -binary-checkbox">
                  {errors.isAceptTCGD && touched.isAceptTCGD && <div className="field-invalid">{errors.isAceptTCGD}</div>}
                  <label htmlFor="isAceptTCGD">
                    <Field id="isAceptTCGD" name="isAceptTCGD" type="checkbox" />
                    <div className="checkmark">
                      <span />
                    </div>
                    <div className="label-text">
                      Otorgo mi consentimiento expreso para que toda la documentación de
                      este seguro, me sea entregada a través del correo electrónico que he
                      proporcionado, el cual fungirá como medio para recibir notificaciones
                      y enviar información paratodo lo relacionado con el seguro y,
                      en su caso, sus siniestros.
                    </div>
                  </label>
                </div>
              </div>
              <div className="field-row">
                <div className="field -binary-checkbox">
                  {errors.AvisoPrivacidad && touched.AvisoPrivacidad && <div className="field-invalid">{errors.AvisoPrivacidad}</div>}
                  <label htmlFor="AvisoPrivacidad">
                    <Field id="AvisoPrivacidad" name="AvisoPrivacidad" type="checkbox" />
                    <div className="checkmark">
                      <span />
                    </div>
                    <div className="label-text">
                      He leído y acepto los&nbsp;
                      <button className="btn-link" type="button" onClick={(event) => handleDocumentsLinkClick(event, 'Terminos Y Condiciones')}>
                        Términos y Condiciones
                      </button>
                      ,&nbsp;
                      <button className="btn-link" type="button" onClick={(event) => handleDocumentsLinkClick(event, 'Condiciones Generales')}>
                        Condiciones Generales
                      </button>
                      ,&nbsp;
                      <button className="btn-link" type="button" onClick={(event) => handleDocumentsLinkClick(event, 'Declaraciones amae')}>
                        Declaraciones
                      </button>
                      &nbsp;y el&nbsp;
                      <button className="btn-link" type="button" onClick={(event) => handleDocumentsLinkClick(event, 'Aviso De Privacidad')}>
                        Aviso de Privacidad.
                      </button>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="form-buttons">
              <Button
                type="submit"
                disabled={!isValid && !isValidating && !isSubmitting}
                label="Continuar"
                direction="forward" />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Form1;
